import BiddingTab from './BiddingTab.vue'
import Comments from './Comments.vue'
import SearchPanel from './SearchPanel.vue'
import Tags from './Tags.vue'
import Record from './Record.vue'

export {BiddingTab, Comments, SearchPanel, Tags, Record}
